/**
 * Модалка редактирования данных клиента (имя и телефон).
 * Открывается поверх всего контента.
 * 
 * Пропсы:
 *   order — объект заявки (нужны id, client_name, client_phone)
 *   token — токен авторизации
 *   onClose — функция закрытия модалки
 *   onSave — колбэк после успешного сохранения
 * 
 * Применяется: Master, Diagnostic
 */

import { useState } from 'react'
import { formatPhone } from '../../shared/lib/phone'

export default function ClientEditModal({ order, token, onClose, onSave }) {
    const [form, setForm] = useState({
        client_name: order?.client_name || '',
        client_phone: order?.client_phone || '',
        vin: order?.vin || '',
        number: order?.number || '',
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    const handleSave = async () => {
        if (!form.client_name || !form.client_phone) return
        setSaving(true)
        setError('')
        try {
            const response = await fetch(`/api/orders/${order.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(form)
            })
            const data = await response.json()
            if (!response.ok) {
                setError(data.message || 'Не удалось сохранить изменения')
                return
            }
            onSave(data)
            onClose()
        } catch {
            setError('Ошибка соединения с сервером')
        } finally {
            setSaving(false)
        }
    }

    const inputStyle = {
        width: '100%', padding: '10px 12px', borderRadius: '10px',
        border: '1.5px solid #E5E7EB', fontSize: '14px',
        boxSizing: 'border-box', outline: 'none', background: 'white'
    }
    const labelStyle = { fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' }

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
            <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '400px', padding: '20px 20px 24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1A1A1A' }}>Данные клиента</h2>
                    <button onClick={onClose} style={{ background: '#F3F4F6', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {error && <div style={{ background: '#FEF2F2', color: '#DC2626', fontSize: '13px', padding: '10px 12px', borderRadius: '8px' }}>{error}</div>}
                    <div>
                        <label style={labelStyle}>Имя клиента *</label>
                        <input
                            value={form.client_name}
                            onChange={e => setForm(p => ({ ...p, client_name: e.target.value }))}
                            placeholder="Иванов Иван"
                            style={inputStyle}
                        />
                    </div>
                    <div>
                        <label style={labelStyle}>VIN</label>
                        <input value={form.vin} onChange={e => setForm(p => ({ ...p, vin: e.target.value.toUpperCase() }))} placeholder="Если есть" style={inputStyle} />
                    </div>
                    <div>
                        <label style={labelStyle}>№ заказ-наряда</label>
                        <input value={form.number} onChange={e => setForm(p => ({ ...p, number: e.target.value }))} placeholder="Если есть" style={inputStyle} />
                    </div>
                    <div>
                        <label style={labelStyle}>Телефон клиента *</label>
                        <input
                            type="tel"
                            value={form.client_phone}
                            onChange={e => setForm(p => ({ ...p, client_phone: formatPhone(e.target.value) }))}
                            placeholder="+7 (900) 000-00-00"
                            style={inputStyle}
                        />
                    </div>
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        style={{ width: '100%', padding: '16px', background: saving ? '#93AEFF' : '#0052FF', color: 'white', border: 'none', borderRadius: '12px', fontSize: '15px', fontWeight: '700', cursor: saving ? 'not-allowed' : 'pointer', marginTop: '8px' }}
                    >
                        {saving ? 'Сохранение...' : 'Сохранить'}
                    </button>
                </div>
            </div>
        </div>
    )
}
